module.exports = ".step {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr;\n      grid-template-columns: 1fr;\n  grid-gap: 10px; }\n  .step div {\n    padding: 20px; }\n  .step .help {\n    padding: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/step-description/step-description.component.scss
// module id = ./src/app/step-description/step-description.component.scss
// module chunks = main